import React, { useEffect, useMemo, useState } from 'react';
import MyInvoisList from './myinvois_list';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import { Button, Checkbox, DatePicker, Input, List, Radio, Space } from 'antd';
import { CaretDownFilled, SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import serviceHelper from '../../../helpers/functions/service.helper';
import FilterBullet from '../../../helpers/components/filter_bullet';
import dayjs from 'dayjs';
import parkService from '../../../services/config/park.service';

const { RangePicker } = DatePicker;
const MyInvoisLayout = ({ default_filter = {}, }) => {
    const { innerWidth } = window;
    const [state, setState] = useState({
        loading : false,
        parks : [],
    })
    const [filter, setFilter] = useState({
        search : default_filter?.search,
        expand_key : default_filter?.expand_key,
        status : default_filter?.status,
    })
    const [timer, setTimer] = useState(null);

    // submission status list
    const submission_statuses = useMemo(() => {
        return [{
            label : 'In Progress',
            value : 'InProgress',
        },{
            label : 'Valid',
            value : 'Valid',
        },{
            label : 'Partially Valid',
            value : 'PartiallyValid',
        },{
            label : 'Invalid',
            value : 'Invalid',
        }];
    }, [])

    const doneTyping = async (input) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            // setFilter(filter => ({ ...filter, search: input, }));
            changeFilter('search', input);
        }, 300);
        setTimer(newTimer);
    }

    // change date
    const changeDate = (key1, key2, date) => {
    if(date){
        const start_date = dayjs(date[0])?.format("YYYY-MM-DD");
        const end_date = dayjs(date[1])?.format("YYYY-MM-DD");

        // setFilter(filter => ({...filter, [key1] : start_date, [key2] : end_date}));
        changeFilter(key1, start_date);
        changeFilter(key2, end_date);
    }else{
        // setFilter(filter => ({...filter, [key1] : null, [key2] : null}));
        changeFilter(key1, null);
        changeFilter(key2, null);
    }
}

    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = default_filter;
        generate_filter[key] = value;
        
        setFilter(filter => ({...filter, ...generate_filter, page : 1,}));
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }

    const initialize = async () => {
        setState(state => ({...state, loading : true, }));

        const parkResponse = await parkService?.getParkByAuth();
        const { parks, } = parkResponse;
        
        setState(state => ({...state, loading : false, parks : parks, }));
    }

    useEffect(() => {
        initialize();
    }, [])

    return (
        <>
            <div className='mobile-padding-12'>
                <div style={{marginBottom: 24, textAlign:'start'}}>
                    <PageHeaderComponent title={'MyInvois Documents'} />
                </div>

                <div>
                    <Input
                    onChange={(e) => doneTyping(e.target.value)}
                    name="search"
                    defaultValue={filter?.search}
                    prefix={<SearchOutlined style={{color :'var(--secondary-text-color)'}} />}
                    placeholder='Search'
                    style={{minWidth: '100%',}}
                    allowClear
                    // {...(errors?.find(x => x?.type === 'search_length') && ({ status : 'warning', }))}
                    />
                    <div style={{display:'flex', alignItems:'center', marginTop:12, gap:8,}}>
                        <div className='filter-panel' style={{textAlign:'start'}}>
                            <Space direction={innerWidth > 768 ? 'horizontal' : 'vertical'}>
                                <FilterBullet
                                popover={
                                    <>
                                        <div>
                                            <Input prefix={<SearchOutlined style={{color :'var(--secondary-text-color)'}}/>} placeholder='Search Parks' />
                                        </div>
                                        
                                        <Checkbox.Group
                                        value={filter?.parks}
                                        onChange={(checkedValues) => changeFilter('parks', checkedValues)}
                                        >
                                            <List
                                            style={{ width:280, }}
                                            dataSource={state?.parks}
                                            renderItem={(item, index) => {
                                                const { park_id, name, } = item ?? {};
                                                return (
                                                    <List.Item style={{width:'100%'}} key={index}>
                                                        <div style={{display:'flex', alignItems:'center', width:'100%'}}>
                                                            <div>
                                                                <span>{name}</span>
                                                            </div>
                                                            <div style={{marginLeft:'auto'}}>
                                                                <Checkbox
                                                                value={park_id}
                                                                />
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                )
                                            }}
                                            />
                                        </Checkbox.Group>
                                    </>
                                }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                                <span>Park {filter?.parks?.length > 0 ? `: ${filter?.parks?.length}` : ''}</span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color:'#a0aec0'}} />
                                            </div>
                                        </Space>
                                        
                                    </div>
                                </FilterBullet>
                                
                                <FilterBullet
                                popover={
                                    <>
                                        <div>
                                            <RangePicker
                                            {...(filter?.start_date && filter?.end_date) && ({ defaultValue : [dayjs(filter?.start_date), dayjs(filter?.end_date)] })}
                                            onChange={(e) => changeDate('start_date', 'end_date', e)} format={"YYYY-MM-DD"} 
                                            />
                                        </div>
                                    </>
                                }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                                <span>Issue Date
                                                    <span style={{fontSize:12, fontWeight:500, color:'var(--secondary-text-color)'}}>
                                                        {filter?.start_date && filter?.end_date && `: ${filter?.start_date}-${filter?.end_date}`}
                                                    </span>
                                                </span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color:'#a0aec0'}} />
                                            </div>
                                        </Space>
                                    </div>
                                </FilterBullet>
                                <FilterBullet
                                popover={
                                    <>
                                        <Radio.Group
                                        value={filter?.status}
                                        onChange={(e) => changeFilter('status', e?.target?.value)}
                                        >
                                            <List
                                            style={{ width:280, }}
                                            dataSource={submission_statuses}
                                            renderItem={(item, index) => {
                                                const { label, value, } = item ?? {};
                                                return (
                                                    <List.Item style={{width:'100%'}} key={index}>
                                                        <div style={{display:'flex', alignItems:'center', width:'100%'}}>
                                                            <div>
                                                                <span>{label}</span>
                                                            </div>
                                                            <div style={{marginLeft:'auto'}}>
                                                                <Radio
                                                                value={value}
                                                                />
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                )
                                            }}
                                            />
                                        </Radio.Group>
                                    </>
                                }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                                <span>Status {filter?.status ? `: ${submission_statuses?.find(x => x?.value === filter?.status)?.label}` : ''}</span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color:'#a0aec0'}} />
                                            </div>
                                        </Space>
                                    </div>
                                </FilterBullet>
                            </Space>
                        </div>
                        <div style={{ marginLeft : 'auto', }}>
                            <Link to="/myinvois/consolidate/generate">
                                <Button type='primary'>Generate Consolidate Invoice</Button>
                            </Link>
                        </div>
                    </div>
                </div>

                <div style={{marginTop:12,}}>
                    <MyInvoisList filter={filter} />
                </div>
            </div>
           
        </>
    );
}

export default MyInvoisLayout;